import React from "react";
import Typography from "@material-ui/core/Typography";

import ReviewSections from "../components/onboarding/reviewSections";
class StepReview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reviewItems: this.props.getStore().user.sections,
    };
  }
  isValidated() {
    return true;
  }
  render() {
    return (
      <div className="step step3">
        <form id="Form" className="form-horizontal">
          <div className="form-group">
            <label className="col-md-12 control-label">
              <Typography variant="h5">Review - Summary of Charges</Typography>
              <div className="your-class mt-3"></div>
              <Typography variant="subtitle1">
                {this.props.getStore().user.reviewTitle}
              </Typography>
              <div className="your-class mt-3"></div>
            </label>

            <ReviewSections splitPayment={this.props.getStore().user.splitPayment} items={this.state.reviewItems}></ReviewSections>
          </div>
        </form>
      </div>
    );
  }
}

export default StepReview;
